import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92167f32"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ODadosProjeto",
  "data-testid": "ODadosProjeto"
}
const _hoisted_2 = { class: "ODadosProjeto__SeletorDeCor" }

import { computed, ref } from "vue"

  import { MInput, MMultiSelect } from "@/components/Gerais"
  import VSwatches from "vue3-swatches"

  import { EntidadeGenerica } from "@/types/gerais"

  import useVuelidate, { ValidationArgs } from "@vuelidate/core"
  import { helpers, maxLength, required } from "@vuelidate/validators"
  import { useI18n } from "vue-i18n"

  interface Props {
    corHexadecimal: string
    nomeProjeto: string
    codigo: string
    usuariosResponsaveis: string[]
    usuariosResponsaveisOpcoes: EntidadeGenerica[]
    escopoValidacao?: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ODadosProjeto',
  props: {
    corHexadecimal: { default: "#E39751" },
    nomeProjeto: null,
    codigo: null,
    usuariosResponsaveis: null,
    usuariosResponsaveisOpcoes: null,
    escopoValidacao: null
  },
  emits: ["update:corHexadecimal", "update:nomeProjeto", "update:codigo", "update:usuariosResponsaveis"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:corHexadecimal", corHexadecimal: string)
    (event: "update:nomeProjeto", nomeProjeto: string)
    (event: "update:codigo", codigo: string)
    (event: "update:usuariosResponsaveis", usuariosResponsaveis: string[]): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { corHexadecimal: string, nomeProjeto: string, codigo: string, usuariosResponsaveis: string[], usuariosResponsaveisOpcoes: EntidadeGenerica[], escopoValidacao?: string }

  

  const PALETA_DE_CORES_DE_PROJETOS = [
    "#59C2CF",
    "#4467C0",
    "#875CCE",
    "#CF5999",
    "#BF5151",
    "#816347",
    "#E39751",
    "#FFCA54",
    "#B0EA52",
    "#3DAF90",
    "#176F65",
    "#566573",
    "#C4C4C4",
    "#333333",
  ]
  const swatches = ref<string[]>(PALETA_DE_CORES_DE_PROJETOS)

  const { t } = useI18n()

  

  const emitirCorHexadecimal = computed({
    get() {
      return props.corHexadecimal || PALETA_DE_CORES_DE_PROJETOS[0]
    },
    set(corHexadecimal: string) {
      emitir("update:corHexadecimal", corHexadecimal)
    },
  })

  const emitirNomeProjeto = computed({
    get() {
      return props.nomeProjeto
    },
    set(nomeProjeto: string) {
      emitir("update:nomeProjeto", nomeProjeto)
    },
  })

  const emitirCodigo = computed({
    get() {
      return props.codigo
    },
    set(codigo: string) {
      emitir("update:codigo", codigo)
    },
  })

  const emitirUsuariosResponsaveis = computed({
    get() {
      return props.usuariosResponsaveis
    },
    set(usuariosResponsaveis: string[]) {
      emitir("update:usuariosResponsaveis", usuariosResponsaveis)
    },
  })

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const regras: ValidationArgs<{ nomeProjeto: any; codigo: any }> = {
    nomeProjeto: {
      obrigatorio: helpers.withMessage(t("campoObrigatorio"), required),
      tamanhoMaximo: helpers.withMessage(t("nomeDoProjetoNaoPodeUltrapassar256Caracteres"), maxLength(256)),
    },
    codigo: {
      obrigatorio: helpers.withMessage(t("campoObrigatorio"), required),
    },
  }

  const v$ = useVuelidate(
    regras,
    {
      nomeProjeto: emitirNomeProjeto,
      codigo: emitirCodigo,
      usuariosResponsaveis: emitirUsuariosResponsaveis,
      corHexadecimal: emitirCorHexadecimal,
    },
    { $scope: props.escopoValidacao }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(VSwatches), {
        modelValue: _unref(emitirCorHexadecimal),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirCorHexadecimal) ? (emitirCorHexadecimal).value = $event : null)),
        "popover-x": "right",
        swatches: swatches.value
      }, null, 8, ["modelValue", "swatches"])
    ]),
    _createVNode(_unref(MInput), {
      modelValue: _unref(v$).nomeProjeto.$model,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).nomeProjeto.$model) = $event)),
      class: _normalizeClass(["ODadosProjeto__Nome", { 'p-invalid': _unref(v$).nomeProjeto.$invalid }]),
      "data-testid": "ODadosProjeto__Nome",
      label: _unref(t)('nomeDoProjeto'),
      "mensagem-de-erro": _unref(v$).nomeProjeto.$errors[0]?.$message,
      nome: "nomeProjeto",
      obrigatorio: "",
      "tipo-entrada": "text"
    }, null, 8, ["modelValue", "class", "label", "mensagem-de-erro"]),
    _createVNode(_unref(MInput), {
      modelValue: _unref(v$).codigo.$model,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).codigo.$model) = $event)),
      class: _normalizeClass(["ODadosProjeto__Codigo", { 'p-invalid': _unref(v$).codigo.$invalid }]),
      "data-testid": "ODadosProjeto__Codigo",
      label: _unref(t)('codigo'),
      "mensagem-de-erro": _unref(v$).codigo.$errors[0]?.$message,
      nome: "codigo",
      obrigatorio: "",
      "tipo-entrada": "text"
    }, null, 8, ["modelValue", "class", "label", "mensagem-de-erro"]),
    _createVNode(_unref(MMultiSelect), {
      modelValue: _unref(emitirUsuariosResponsaveis),
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(emitirUsuariosResponsaveis) ? (emitirUsuariosResponsaveis).value = $event : null)),
      class: "ODadosProjeto__UsuariosResponsaveis",
      "data-testid": "ODadosProjeto__UsuariosResponsaveis",
      "exibicao-de-opcoes": "comma",
      "maximo-de-legendas-selecionadas": 3,
      "option-label": "nome",
      "option-value": "id",
      options: __props.usuariosResponsaveisOpcoes,
      placeholder: _unref(t)('usuariosResponsaveis'),
      width: "100px"
    }, null, 8, ["modelValue", "options", "placeholder"])
  ]))
}
}

})